import React,{useState,useEffect} from 'react';
import Calendar from 'react-calendar';
import Bottom_menu from './Bottom_menu';
import {formatDate,formatDate2,comma,instance, currentDate} from './common';
import axios from 'axios';
import Pagination from "react-js-pagination";
import TopTitle from './TopTitle';
import arrow from './img/right icon.png';

function totalPrice(data,co_discount) {
    let price = 0;
    data.forEach(function (v) {
        price += Number(v.s_member_price);
        if(v.c_option){
            JSON.parse(v.c_option).forEach(function(items){
                price += Number(items.price);
            });
        }
    });
    price =  price-co_discount;
    return comma(price);
}


function MakeBtn({ status, gumsu, enddate, gubun, r_id, history, s_id}) {
    
    let str = '';
    let classStr = '';
    const btnRadius = {
        borderRadius: '5px'
    }
    if (gumsu === null && enddate === null && gubun === '현장') {
        str = '현장결제';
        classStr = 'btn btn-success col-6'
    } else if (gumsu === null && enddate === null && gubun === '온라인') {
        str = '앱 결제';
        classStr = 'btn btn-danger col-6'
    } else if (gumsu === null && enddate === null && gubun === '') {
        str = '신청완료';
        classStr = 'btn btn-info col-6'
    }

    if (status === '입고완료') {
        str = '입고완료';
        classStr = 'btn btn-warning col-6 text-white'
    } else if (status === '검수완료') {
        str = '검수완료';
        classStr = 'btn btn-primary col-6'
    } else if (status === "작업완료") {
        str = '작업완료';
        classStr = 'btn btn-secondary col-6'
    }
    const [value, onChange] = useState(new Date());
    const goPage = (e) => {
        const rr_id = e.target.dataset.id;
        if(e.target.dataset.name === "신청완료"){
            const category = JSON.parse(s_id)[0].s_cate;
            if (category === '썬가드하이퍼이벤트') 
                return history.push(`/Si_reserve_detail?r_id=${rr_id}&date=${formatDate(value)}`);
            alert('결제가 되지않은 예약건입니다.');
        }else{
            if(window.confirm('작업을 진행하시겠습니까?')){            
                if (e.target.dataset.name === "현장결제") {      
                    if(e.target.dataset.s_id){
                        history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                    }else{
                        history.push('/apply?r_id='+rr_id);
                    }
                }else if(e.target.dataset.name === "앱 결제") {
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }else if(e.target.dataset.name === "입고완료"){
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }else if(e.target.dataset.name === "검수완료"){
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }else if(e.target.dataset.name === "작업완료"){
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }
            }
        }
    }

    return (
        <div className={classStr} style={btnRadius} onClick={goPage} data-name={str} data-id={r_id} data-s_id={s_id}>{str}</div>
    )

}

function setName(v) {
    let name = '';
    JSON.parse(v.s_id).forEach(function (items) {
        if (JSON.parse(v.s_id).length > 1) {
            name = JSON.parse(v.s_id)[0].s_name + ' 외 ' + JSON.parse(v.s_id).length + '개';
        } else {
            name = JSON.parse(v.s_id)[0].s_name;
        }
    });

    return name;
}

function LoadData({history,r_reserve_date}) {

    const [optionValue, setOptionValue]  = useState(window.sessionStorage.getItem('optionValue') ? window.sessionStorage.getItem('optionValue') : 'all');
    const [data, setData] = useState([]);
    const [finisData, setfinishData] = useState(0);
    const [fix_total, setFixtotal] = useState(0);
    const ppp = 10;
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const [r_status, setR_status] = useState('');

    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;

    let obj = {
        page: page,
        ppp: ppp,
        si_id: si_id,
        r_status: r_status,
        r_reserve_date: r_reserve_date,
    }

    useEffect(() => {

        const fetchData = async () => {
            instance.post(`/${optionValue}/month`, obj).then(function (res) {
                console.log('res : ', res.data)
                setData(res.data.rows);
                setfinishData(res.data.finishCount);
                setTotal(res.data.totalCount);
                setFixtotal(res.data.total_fix);
            });

        };
        fetchData();
    }, [page, ppp, si_id, r_status, r_reserve_date,optionValue]);

    const tabSearch = {
        whiteSpace: 'nowrap'
    }
    const grayLine = {
        border: 'solid 1px black',
    }

    const onClick = (e) => {
        const { r_status } = e.target.dataset;
        setR_status(r_status);      
    }
    const pageChange = (pageNumber) => {
        setPage(pageNumber);
    }

    
    const goLink = (cate,seq) => {
        if(cate === 'k' || cate === 'sun' || cate === 'btob'){
            window.sessionStorage.setItem('optionValue',cate)
            history.push('/work?seq='+seq+'&cate='+cate);
        }else{
            history.push('/work?seq='+seq);
        }
    }
    return (
        <>
            <div className="container">
                <select className="form-control d-inline-block w-50 px-0 mb-4 float-right" onChange={(e) => {setOptionValue(e.target.value)}}>
                     <option value="all">전체</option>
                    <option value="hy">D2C 할부 신차패키지</option>
                    <option value="k">K-Solution 카케어서비스</option>
                    <option value="sun">썬가드 신차패키지</option>
                    <option value="btob">BtoB 서비스</option>
                </select>
                <div style={{clear:'both'}}></div>
                <div className="row mb-3 px-0 text-center">
                    <div className="col-4 px-0 border-right font-weight-bold" onClick={() => {setR_status('')}} data-r_status="">전체 {fix_total}건</div>
                    <div className="col-4 px-0 border-right font-weight-bold" style={tabSearch} onClick={() => {setR_status('완료')}} data-r_status="작업완료">작업완료 {finisData}건</div>
                    <div className="col-4 px-0 font-weight-bold">취소 0건</div>
                </div>
                <div style={grayLine}></div>
                <div className="row p-0">
                    <table className="table table-bordered text-center">
                        <thead>
                            <tr>
                                <th>예약번호</th>
                                <th>프로젝트명</th>
                                <th>차종</th>
                                <th>차량번호</th>
                                <th>진행상태</th>
                            </tr>
                        </thead>
                        <tbody>
                           { data.map((v,i) => <tr key={i}>
                               <td><span onClick={() => goLink(v.cate,v.seq)} style={{color:'#06f',cursor:'pointer'}}>{v.re_date}</span></td>
                               <td>{getProjectName(v.cate)}</td>
                               <td>{v.u_car_name}</td>
                               <td>{v.u_car_number}</td>
                               <td>{v.r_status}</td>
                           </tr>)}
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                </div>
            </div>
            <div className="text-center">
                <Pagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={total}
                    pageRangeDisplayed={10}
                    onChange={pageChange}
                />
            </div>
        </>
    )
}

function GetProductName({product}){
    let [prod, setProduct]= useState([]);
    useEffect(() => {
        instance.post(`/hy/sigong/name`, {product:product}).then(function (res) {
            console.log('res : ', res.data)
            if(res.data.length !=0){
                setProduct(res.data)
            }
        });
    },[])

    return (
        <>
        {prod.map((v,i) => <span>{v.sub && '('+v.sub+')'} {v.title} {i == prod.length - 1 ? '' : ' + '}</span>)}
        </>
    )

}


function HyBtn({ status,history, seq}){
    let str = '';
    let classStr = '';
    const btnRadius = {
        borderRadius: '5px'
    }

    if (status === '입고완료') {
        str = '입고완료';
        classStr = 'btn btn-warning col-6 text-white'
    } else if(status === '예약완료'){
         str = '예약완료';
        classStr = 'btn btn-info col-6 text-white'
    }else if(status === '결제완료'){
        str = '결제완료';
       classStr = 'btn btn-success col-6 text-white'
   }else if (status === '검수완료') {
        str = '검수완료';
        classStr = 'btn btn-primary col-6'
    } else if (status === "작업완료") {
        str = '작업완료';
        classStr = 'btn btn-secondary col-6'
    }
    const [value, onChange] = useState(new Date());
    const goPage = (e) => {
        const rr_id = e.target.dataset.id;
        if(e.target.dataset.name === "예약완료"){
            alert('결제가 되지않은 예약건입니다.');
        }else{
            if(window.confirm('작업을 진행하시겠습니까?')){            
                //history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                history.push('/work?seq='+seq);
            }
        }
    }

    return (
        <div className={classStr} style={btnRadius} onClick={goPage} data-name={str}>{str}</div>
    )
}


function SunBtn({ status,history, seq, cate}){

    let str = '';
    let classStr = '';
    const btnRadius = {
        borderRadius: '5px'
    }

    if (status === '입고완료') {
        str = '입고완료';
        classStr = 'btn btn-warning col-6 text-white'
    } else if(status === '예약완료'){
         str = '예약완료';
        classStr = 'btn btn-info col-6 text-white'
    }else if(status === '결제완료'){
        str = '결제완료';
       classStr = 'btn btn-success col-6 text-white'
   }else if (status === '검수완료') {
        str = '검수완료';
        classStr = 'btn btn-primary col-6'
    } else if (status === "작업완료") {
        str = '작업완료';
        classStr = 'btn btn-secondary col-6'
    }
    const [value, onChange] = useState(new Date());
    const goPage = (e) => {
        const rr_id = e.target.dataset.id;
        if(e.target.dataset.name === "예약완료"){
            alert('결제가 되지않은 예약건입니다.');
        }else{
            if(window.confirm('작업을 진행하시겠습니까?')){            
                //history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                history.push('/work?seq='+seq+'&cate='+cate);
            }
        }
    }

    return (
        <div className={classStr} style={btnRadius} onClick={goPage} data-name={str}>{str}</div>
    )
}


function activeTileCheck(data,date){
    let chkBoolean = false;
    data.forEach(function(v){
        if(v.r_reserve_date !== currentDate() && v.r_reserve_date === formatDate(date)){       
            chkBoolean = true; 
            return false;
        }
    });
    return chkBoolean;
}


function getProjectName(named){
    let changeName = named;
    if(named === 'k'){
        changeName = 'K-Solution 카케어서비스';
    }else if(named === 'sun'){
        changeName = '썬가드 신차패키지';
    }else if(named === 'btob'){
        changeName = 'BtoB 서비스';
    }
    return changeName;
}

function Month_list({history}){


    const [data, setData] = useState([]);
    let now = new Date();
    let f_date = new Date(now.getFullYear(), now.getMonth(), 1);
    let l_date = new Date(now.getFullYear(), now.getMonth()+1, 0);
    

    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;


    
    useEffect(() => {
        let obj ={
            f_date:formatDate(f_date),
            l_date:formatDate(l_date),
            si_id:si_id
        }
        const fetchData = async () => {
            instance.post('/reserve/calendar', obj).then(function (res) {
                setData(res.data.rows);
            });

        };
        fetchData();
    }, []);
    


    const [value, onChange] = useState(new Date());

    const [show, setShow] = useState(true);
    const ab = {
        position:'absolute',
        right:'15px',
        top:'5px',
        color:'#A0A096'
    }

    const arrow_style = {
        width:'20px',
        transform: show ? 'rotate(90deg)' : 'rotate(270deg)'
    }

    const showChange = () => {
        setShow(!show)
    }



    console.log('data : ', data)
    const tileClassName = ({date, view}) => activeTileCheck(data,date) && 'activeTile'

    return (
        <>
            <div style={{position:'relative'}}>
                <TopTitle title="월별 일정"/>
                <span style={ab} onClick={showChange}>달력 접기 <img src={arrow} style={arrow_style}/></span>
            </div>
            {
                show  && 
                <>
                <div className="text-right pr-3"><span className="bg-g"></span> : 예약일자</div>
                <div className="text-right pr-3"><span className="bg-t"></span> : 선택일자</div>
                <Calendar 
                className="mb-5 c_mgauto" 
                onChange={onChange} 
                value={value}
                tileClassName={tileClassName}
                />
                </>
            }
            
            <div className="container mb-3">
                <h4 className="font-weight-bold">{formatDate2(value)}</h4>
            </div>
            <LoadData r_reserve_date={formatDate(value)} history={history}/>
            <Bottom_menu />
        </>
    )
}


export default Month_list;